import AppointmentsRow from "./AppointmentsRow";

export default function RescheduledAppointments({rescheduledAppointments}) {
    return <>
        {rescheduledAppointments.map((item) => (
            <AppointmentsRow key={item.id} data={item} isRescheduled={true}/>
        ))}
    </>
}